export const REBUZZ_STATISTICS_TIME_UNITS = {
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
};

export const REBUZZ_STATISTICS_PERIODICITIES = [
  REBUZZ_STATISTICS_TIME_UNITS.YEAR,
  REBUZZ_STATISTICS_TIME_UNITS.MONTH,
  REBUZZ_STATISTICS_TIME_UNITS.WEEK,
  REBUZZ_STATISTICS_TIME_UNITS.DAY,
];
